import { RouterInputs, ReactQueryOptions, api } from '@api'
import { staleTimeIndex } from '@specs/constants'

type inputType = RouterInputs['CollectionManager']['getCollectionOfTheWeek']
type queryOptionsType = ReactQueryOptions['CollectionManager']['getCollectionOfTheWeek']

export const useGetCollectionOfTheWeek = (input: inputType, options?: queryOptionsType) => {
    return api.CollectionManager.getCollectionOfTheWeek.useQuery(input, {
        ...options,
        queryKey: ['CollectionManager.getCollectionOfTheWeek', input],
        staleTime: 1000 * staleTimeIndex * 60 * 60, // 1 hour
    })
}
